import React, { useState, useEffect } from 'react';
import Fade from '@material-ui/core/Fade';
import MyPolicyList from './components/myPolicies/MyPolicyList';
import MyPolicyDetail from './components/myPolicies/MyPolicyDetail';

const MyPolicies = () => {

    const [step, setStep] = useState(1);
    const [stepBack, setStepBack] = useState(null);
    const [showFade, setShowFade] = useState(true);
  
    const [policy, setPolicy] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step]);
    
    const onBack = (toStep) => {
        toStep = stepBack ? stepBack : toStep;
        setShowFade(false);

        setTimeout(() => {
        setStep(toStep);
        setStepBack(null);
        setShowFade(true);
        }, 0);
    }

    const onForward = (toStep, backTo, newPolicy) => {
        backTo ? setStepBack(backTo) : setStepBack(false);
        setShowFade(false);
  
        if(toStep === 2) {
          setPolicy(newPolicy);
        }
  
        setTimeout(() => {
          setStep(toStep);
          setShowFade(true);
        }, 0);
        
    }

    const renderStepScreen = () => {
        switch (step) {
            case 1:
              return <MyPolicyList onForward={onForward} />;
            case 2:
              return <MyPolicyDetail onForward={onForward} onBack={onBack} policy={policy}/>;              
  
            default:
              return <div></div>;
        }
    }

    return (
        <div style={{position: 'realtive'}}>
            <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
              {renderStepScreen()}
            </Fade>
        </div>
    )
}

export default MyPolicies;
